import { bitcoinHistoricalData } from "@/Groups/Scanner/private/api/bitcoinHistoricalData";

const state = () => ({
  chartData: [],
  isReady: false,
});

const actions = {
  async initChartData({ commit, state }){
    const data = await bitcoinHistoricalData();
    commit('SET_DATA', data);
    commit('SET_READY_FLAG', true);
  },

  async clearData({ commit }){
    commit('SET_DATA', []);
    commit('SET_READY_FLAG', false);
  }
};

const mutations = {
  SET_DATA(state, data){
    console.log('ааываываываывав')
    state.chartData = data;
  },

  SET_READY_FLAG(state, status){
    state.isReady = status;
  }
};

const getters = {
  getChartData: (state) => state.chartData,

  getIsReady: (state) => state.isReady,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};